import {
    Box,
    Stack,
    Typography
} from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { LoginContext } from '../../contexts/LoginContext';

const educationalImages = [
    'https://images.unsplash.com/photo-1638132035918-90a22beaab3b?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1638132035918-90a22beaab3b?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    // 'https://images.unsplash.com/photo-1676302440263-c6b4cea29567?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    // 'https://plus.unsplash.com/premium_photo-1683887033239-08a75665a069?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    // 'https://plus.unsplash.com/premium_photo-1724800663657-3e57bf4f622c?q=80&w=1926&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    // 'https://images.unsplash.com/photo-1596496555041-9e0f141ca4b7?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    // 'https://cdn.pixabay.com/photo/2018/01/17/07/06/laptop-3087585_1280.jpg',
];

export default function WaghTutorial() {
    const { providerDetails } = useContext(LoginContext);
    console.log(providerDetails, 'provdls')
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
    };

    const [animationKey, setAnimationKey] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimationKey(prev => prev + 1);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <Box sx={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
            {/* Transparent AppBar */}
            {/* <AppBar position="absolute" sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
                <Toolbar>
                    <Avatar
                        alt="Logo"
                        src="https://fplogoimages.withfloats.com/actual/6710b0060138247dabe1f86a.png"
                        sx={{ width: 56, height: 56, marginRight: 2 }}
                    />
                </Toolbar>
            </AppBar> */}

            {/* Background Carousel */}
            <Box sx={{ position: 'relative', height: '100vh' }}>
                <Slider {...settings}>
                    {educationalImages.map((img, index) => (
                        <Box
                            key={index}
                            sx={{
                                backgroundImage: `url(${img})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                height: '100vh',
                            }}
                        />
                    ))}
                </Slider>

                {/* Foreground Content */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        // backgroundColor: 'rgb(0 0 0 / 65%)',
                        backgroundColor: 'rgb(0 0 0 / 1%)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#fff',
                        textAlign: 'center',
                        p: 2,
                        zIndex: 1,
                    }}
                >
                    {/* <Avatar
                        alt="Logo"
                        src="https://fplogoimages.withfloats.com/actual/6710b0060138247dabe1f86a.png"
                        sx={{ width: 100, height: 100, marginRight: 2 }}
                    /> */}
                    <img
                        src={providerDetails?.logo ?? "/SignInBannermerged.PNG"}  // Replace with your SVG path
                        alt="SVG Image"
                        style={{
                            width: '50%',   //'auto',  // Adjust width as necessary
                            height: 'auto',  // Adjust height as necessary
                            // position: 'absolute',
                            left: '10%',
                            // overflow: 'hidden'
                        }}
                    />
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={animationKey}
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 1.05 }}
                            transition={{ duration: 1 }}
                        >
                            <Typography
                                variant="h3"
                                sx={{
                                    color: '#012248',
                                    fontWeight: 'bold',
                                    mt: 2,
                                    fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                                }}
                            >
                                Prof. Ajaykumar Wagh Tutorials
                            </Typography>
                        </motion.div>
                    </AnimatePresence>
                    <Stack direction="row" spacing={4} mt={2}>

                        <Typography variant="h5" sx={{ color: '#012248', fontSize: { xs: '1rem', md: '1.25rem', lg: '1.7rem' } }}>
                            📞 +91- 99221 15577
                        </Typography>
                        <Typography variant="h5" sx={{ color: '#012248', fontSize: { xs: '1rem', md: '1.25rem', lg: '1.7rem' } }}>
                            📍 Nashik, India
                        </Typography>
                    </Stack>
                    {/* Social Icons */}
                    {/* <Stack direction="row" spacing={2} mt={2}>
                        <IconButton
                            href="https://wa.me/91XXXXXXXXXX"
                            target="_blank"
                            sx={{ color: '#25D366' }}
                        >
                            <WhatsApp fontSize="large" />
                        </IconButton>
                        <IconButton
                            href="https://linkedin.com/in/yourprofile"
                            target="_blank"
                            sx={{ color: '#0077b5' }}
                        >
                            <LinkedIn fontSize="large" />
                        </IconButton>
                        <IconButton
                            href="https://github.com/yourusername"
                            target="_blank"
                            sx={{ color: '#fff' }}
                        >
                            <GitHub fontSize="large" />
                        </IconButton>
                    </Stack> */}
                </Box>
            </Box>
        </Box>
    );
}
